
































import { defineComponent } from '@vue/composition-api';
import Panel from '@/features/ui/panel/Panel.global.vue';
import PropertyList from '@/features/app-enterprise-project/views/enterprise-project-create/components/step2/PropertyList.vue';
import { mapGetters, mapState } from 'vuex';
import { InputValidationMixin } from '@/features/core/components/mixins/input-validation';
import PropertyElevatorAssociation from '@/features/app-enterprise-project/views/enterprise-project-create/components/elevator-assignment/PropertyElevatorAssociation.vue';
import CreateBuildingsButton from '@/features/app-enterprise-project/views/enterprise-project-create/components/CreateBuildingsButton.vue';
import { ProjectBuilding } from '@/features/core/store/page-modules/enterprise-project-create/create-module-types';
import WizardButton from '@/components/clickables/WizardButton.global.vue';

export default defineComponent<any, Record<string, unknown>, any, any>({
  components: {
    WizardButton,
    CreateBuildingsButton,
    PropertyElevatorAssociation,
    PropertyList,
    Panel,
  },
  mixins: [InputValidationMixin],
  props: {},
  data() {
    return {
      buildingFormData: null,
    };
  },
  computed: {
    ...mapGetters(['mainBuildingsWithComments', 'buildingsWithElevators']),
    ...mapState({
      newProjectData: (state: any) => state.EnterpriseProjectCreateModule.newProjectData,
      buildings: (state: any) => state.EnterpriseProjectCreateModule.newProjectData.buildings,
      activeStep1BuildingId: (state: any) => state.EnterpriseProjectCreateModule.activeStep1BuildingId,
      activeStep2BuildingId: (state: any) => state.EnterpriseProjectCreateModule.activeStep2BuildingId,
      saving: (state: any) => state.EnterpriseProjectCreateModule.saving,
      activeBuilding: (state: any) => {
        if (
          state.EnterpriseProjectCreateModule.newProjectData.buildings &&
          state.EnterpriseProjectCreateModule.newProjectData.buildings?.length > 0
        ) {
          return state.EnterpriseProjectCreateModule.newProjectData.buildings.find(
            (building: ProjectBuilding) =>
              building.buildingId === state.EnterpriseProjectCreateModule.activeStep1BuildingId,
          );
        }
      },
    }),
  },
  methods: {
    goToStep(step: string) {
      this.$store.dispatch('setUpdateTab', step);
      if (step !== 'step1') {
        this.$store.dispatch('saveToDB', { apolloClient: this.$apollo, finalSave: false });
      }
    },
    updateBuildingFormData(formData: any) {
      this.buildingFormData = formData;
    },
    // We put the functions here so that we can call to submit of the form, from outside the component
    validateBuildingInformationForm() {
      if (!this.buildingFormData) return false;
      return (
        this.validateEmail(this.buildingFormData.email) &&
        this.buildingFormData.phoneNumber &&
        this.buildingFormData.firstName &&
        this.buildingFormData.surname &&
        this.buildingFormData.title
      );
    },
    submitBuildingForm() {
      // Access the form's method triggerSubmit via ref
      if (this.$refs.projectBuildingForm) {
        this.$refs.projectBuildingForm.triggerSubmit();
      }
    },
    passOnHideEvent() {
      this.$emit('hide');
    },
    goToCommentSection() {
      this.$store.dispatch('setUpdateTab', 'comments');
      this.$store.dispatch('saveToDB', { apolloClient: this.$apollo, finalSave: false });
    },
    canMoveToNextSection(): boolean {
      // To keep all the main building Ids where there's an elevator for the main or any of the child buildings
      const mainBuildingsElevatorSet: Set<number> = new Set();

      // Populate the set based on buildings with selected elevators
      for (const building of this.buildings) {
        if (building.hasElevator) {
          if (building.liegenshaft) {
            // Add the building id to the set
            mainBuildingsElevatorSet.add(building.buildingId);
          } else if (building.parentProperty) {
            // Add the linked main building id to the set
            mainBuildingsElevatorSet.add(building.parentProperty);
          }
        }
      }

      // Ensure all the main buildings on the elevator list are included in the set
      const allMainBuildingsIncludeElevators = this.buildingsWithElevators.every((building: ProjectBuilding) =>
        mainBuildingsElevatorSet.has(building.buildingId),
      );

      return allMainBuildingsIncludeElevators;
    },
    shouldDisplayCreateBuildingsButton(): boolean {
      return this.mainBuildingsWithComments.length == 0;
    },
  },
});
